import { StoreonModule } from 'storeon'
import { useStoreon } from 'storeon/react'

import isBoolean from 'lodash/isBoolean'
import isEqual from 'lodash/isEqual'
import pickBy from 'lodash/pickBy'

const KEY = 'ui'

// `projects` used to live here too (the /work page fed the full record
// array in and it was persisted to localStorage on every visit) — the
// case-page paginator now gets its neighbors from the server instead.
interface StateValues {
  gdprAccepted: boolean
}

const INITIAL_STATE = {
  gdprAccepted: false,
}

export interface State {
  [KEY]: StateValues
}

export interface Events {
  updateUi: Partial<StateValues>
  clear: void
}

const uiModule: StoreonModule<State, Events> = store => {
  store.on('@init', () => ({
    [KEY]: INITIAL_STATE,
  }))

  store.on('updateUi', (state, variables) => {
    const values = pickBy(variables, (value, name) => {
      switch (name) {
        case 'gdprAccepted':
          return isBoolean(value)
        default:
          break
      }
    })

    const nextUi = { ...state[KEY], ...values }

    if (isEqual(nextUi, state[KEY])) return null

    return { [KEY]: nextUi }
  })
}

function useUI() {
  const { ui: uiState } = useStoreon<State, Events>(KEY)

  return { ui: uiState }
}

export default uiModule

export { INITIAL_STATE, KEY, useUI }
